import { Badge } from "@chakra-ui/core"
import React from "reactn"
export function ListBadge({ g }) {
  return (
    <Badge key={g} rounded="sm" px="2" mr="2">
      {g}
    </Badge>
  )
}
